module.exports = __webpack_public_path__ + "static/media/aboutimg3.dda7becc.jpg";